import React from 'react';
import { useAuth } from 'hooks/useAuth';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const UserAction = ({ to, children, operator, permissions, component, color, ...rest }) => {
  const { hasPermission } = useAuth();
  if (!hasPermission(permissions)) {
    if (component) {
      return <>{component}</>;
    } else return <> </>;
  }
  return <>{children}</>;
};

const AllowedGuard = (props) => {
  const { children, permission, component } = props;
  const { hasPermission } = useAuth();
  if (permission !== undefined) {
    if (!hasPermission(permission)) {
      if (component) {
        return component;
      }
      return <></>;
    }
  }
  return children;
};
const AllowedLink = (props) => {
  const { permission, to, children, label } = props;
  const { hasPermission } = useAuth();
  if (!hasPermission(permission)) {
    return <></>;
  }
  return <NavLink to={to}>{children ? children : label}</NavLink>;
};

UserAction.propTypes = {
  children: PropTypes.node
  // permissions: PropTypes.object
};
AllowedLink.propTypes = {
  to: PropTypes.string.isRequired,
  permission: PropTypes.number.isRequired,
  children: PropTypes.node,
  label: PropTypes.string
};

AllowedGuard.propTypes = {
  children: PropTypes.node,
  component: PropTypes.node,
  permission: PropTypes.number
};
export default UserAction;
export { AllowedGuard, AllowedLink };
